import { useQuery } from '@tanstack/react-query'
import { listProfitTaking, topProfitTaking } from '@/lib/profitTakingApi'

const PROFIT_TAKING_KEY = ['profitTaking'] as const

/**
 * Vollständige Profit-Taking-Auswertung für die Detail-Page.
 * Server berechnet alle Trigger pro Position bei jedem Call (kein Cache),
 * aber Client cached 30 s — bei Reload kein zweiter Roundtrip.
 */
export function useProfitTakingList() {
  return useQuery({
    queryKey: [...PROFIT_TAKING_KEY, 'list'],
    queryFn: listProfitTaking,
    staleTime: 30_000,
  })
}

/**
 * Top-N für das Dashboard-Widget. Höhere Polling-Frequenz, weil prominent.
 */
export function useProfitTakingTop(limit = 3) {
  return useQuery({
    queryKey: [...PROFIT_TAKING_KEY, 'top', limit],
    queryFn: () => topProfitTaking(limit),
    staleTime: 60_000,
  })
}
